// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '../static/css/quanju.css'
// import '../static/js/rem.js'
// import '../static/icon/iconfont.css'
import store from '../src/store/index.js'






Vue.config.productionTip = false
Vue.use(ElementUI)
ElementUI.Dialog.props.closeOnClickModal.default = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
 //  beforeCreate() {
 //  	Vue.prototype.$bus = this //安装全局事件总线
	// //传事件
	// //this.$bus.$emit('事件名称'，参数)
	// // 接受事件
	// // this.$bus.$on('事件名称',(data)=> {
		
	// // })
	// //记得解绑
	// // a给b传递数据
	// // b绑定事件总线自定义事件 $on
 //  }
})



// WEBPACK FOOTER //
// ./src/main.js